module.exports = __webpack_public_path__ + "img/foto-bruno-fagundes.jpg";